module.exports = __webpack_public_path__ + "static/qognitiv_prez-bbc3fb732c507b2e802f16bfeee71ca6.webm";